var React = require('react');

function FooterCaret (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 6L8 11L3 6","stroke":"#50555E","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

FooterCaret.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = FooterCaret;

FooterCaret.default = FooterCaret;
